import { toPostUI } from '../../../../mappers/posts/toPostUI';
import { calculateGridCardHeight } from '../../../../ui/posts/PostCardGrid/utils';
import { hasAvailableProducts } from '../../../../utils/hasAvailableProducts';
import { UsePostsCollectionPayload } from '../../../post/usePostCollection';

export const getItemHeightMiddleware =
    (collection: UsePostsCollectionPayload) => (index: number, width: number) => {
        const postModel = collection.items[index];
        if (!postModel) {
            return 0;
        }

        return calculateGridCardHeight(width, toPostUI(postModel).content, postModel.postType, {
            withProductsPreview: hasAvailableProducts(postModel),
        });
    };
